import {
  QuoteFeeTemplatesService,
  QuoteNumberSequenceService,
  TenantQuotingSettingsService,
} from "@common/client"
import { makeAxiosMutation, makeNoArgsQuery, makeQuery } from "../utils"

export const quoteFeeTemplatesKey = ["quote-fee-templates"] as const

export const quoteFeeTemplatesQuery = makeQuery({
  serviceCall: QuoteFeeTemplatesService.listQuoteFeeTemplates,
  queryKey: (params) => [...quoteFeeTemplatesKey, params],
})

export const tenantQuotingSettingsKey = ["tenant-quoting-settings"] as const

export const tenantQuotingSettingsQuery = makeNoArgsQuery({
  serviceCall: TenantQuotingSettingsService.getTenantQuotingSettings,
  queryKey: tenantQuotingSettingsKey,
})

export const useUpsertTenantQuotingSettingsMutation = makeAxiosMutation({
  serviceCall: TenantQuotingSettingsService.upsertTenantQuotingSettings,
  invalidates: () => [tenantQuotingSettingsKey],
})

export const quoteNumberSequenceKey = ["quote-number-sequence"] as const

export const quoteNumberSequenceQuery = makeNoArgsQuery({
  serviceCall: QuoteNumberSequenceService.getQuoteNumberSequence,
  queryKey: quoteNumberSequenceKey,
})

export const useUpsertQuoteNumberSequenceMutation = makeAxiosMutation({
  serviceCall: QuoteNumberSequenceService.upsertQuoteNumberSequence,
  invalidates: () => [quoteNumberSequenceKey],
})
